module.exports = __webpack_public_path__ + "img/Container (3).19c34776.png";